import { useEffect, useState } from 'react';
import { useTheme } from 'next-themes';
import { Monitor, Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';

type Mode = 'light' | 'dark' | 'system';

const ORDER: Mode[] = ['light', 'dark', 'system'];

const NEXT_LABEL: Record<Mode, string> = {
  light: 'Switch to dark theme',
  dark: 'Switch to system theme',
  system: 'Switch to light theme',
};

export interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const current: Mode = mounted && theme && (ORDER as string[]).includes(theme)
    ? (theme as Mode)
    : 'system';

  const cycle = () => {
    const idx = ORDER.indexOf(current);
    const next = ORDER[(idx + 1) % ORDER.length];
    setTheme(next);
  };

  const Icon = current === 'light' ? Sun : current === 'dark' ? Moon : Monitor;

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={mounted ? NEXT_LABEL[current] : 'Theme toggle'}
      title={mounted ? NEXT_LABEL[current] : undefined}
      className={cn('btn-ghost inline-flex h-9 w-9 items-center justify-center p-0', className)}
    >
      {mounted ? <Icon className="h-4 w-4" strokeWidth={1.75} /> : <span className="h-4 w-4" aria-hidden="true" />}
    </button>
  );
}

export default ThemeToggle;
